import { CustomField, Proof, StopKind } from "@app/domain";

export type StopDetailItems = {
  addressDetail?: string;
  customerDescription?: string;
  note?: string;
  proofs: Proof[];
  customFields: CustomField[];
};

/**
 * Total number of information items Stop Details actually renders for a
 * stop: the address-detail line (if present), the customer description (if
 * present), the note (if present), each proof, and each custom field. The
 * single source of truth for that count — shared by the badge on Order
 * Details' Pickup/Dropoff rows (`StopSummary.detailsCount`, derived from
 * this in the mock fixtures) and, indirectly, by Stop Details itself, so the
 * two can never drift apart.
 */
export const countStopDetailItems = ({ addressDetail, customerDescription, note, proofs, customFields }: StopDetailItems): number =>
  (addressDetail ? 1 : 0) + (customerDescription ? 1 : 0) + (note ? 1 : 0) + proofs.length + customFields.length;

/**
 * Whether Stop Details hides a stop's Proof and Details (custom fields)
 * sections entirely — true only for the Pickup stop while dropoff-tracking
 * is active (see `StopDetailsPage`). Shared with `toOrderSummary` so the
 * `detailsCount` badge on Order Details' Pickup row never counts items the
 * customer can't actually see.
 */
export const isStopDetailsHidden = (kind: StopKind, isDropoffTracking: boolean): boolean =>
  kind === "pickup" && isDropoffTracking;
